import { FC } from 'react';
import EmailVerificationIcon from '../../../../assets/images/svg/EmailVerificationIcon';
import {
  CardContainer,
  CardIconHeader,
} from '../../../../shared/components/card';

interface ConfirmationTemplateTemplateProps {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  isError?: boolean;
}

const ConfirmationTemplate: FC<ConfirmationTemplateTemplateProps> = ({
  title,
  subtitle,
  icon,
  isError = false,
}) => {
  return (
    <CardContainer
      className='w-full bg-white rounded-lg shadow'
      header={
        <CardIconHeader
          headerHeight='AUTO'
          withBorder={false}
          icon={icon ? icon : <EmailVerificationIcon isError={isError} />}
          title={title}
          subtitle={subtitle}
        />
      }
    ></CardContainer>
  );
};

export default ConfirmationTemplate;
